import Knight from './Knight';
import { KnightController } from './knightController';

export default Knight;
export { KnightController };